module.exports = __webpack_public_path__ + "static/media/sih_.1213f3e2.jpg";